<template>
    <v-dialog v-model="dialogEmpleado" persistent max-width="1200px" max-height=" 1200px">
        <v-card class="scroll">
            <v-toolbar dark color="bluePrimary" style="border-radius: 10px 10px 0px 0px;">

                <v-toolbar-title>Información personal</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn icon dark @click="closeDialog()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>


            <v-card>
                <v-card-text class="pt-5">
                    <v-row>
                    <v-col cols="12" md="3" class="d-flex align-center justify-center" v-if="showImage()">
                        <v-avatar height="200" width="200" class="xs12 sm6 md4 lg3 xl2">
                            <v-img
                                src="@/assets/img/default_user.png"
                                alt="Foto de perfil"
                                style="object-fit: cover !important; object-position: top !important;"
                            />
                        </v-avatar>
                    </v-col>
                    <v-col cols="12" md="9">
                            <v-card-subtitle class="mx-0 px-0 font-weight-black text-h5 mb-5 bluePrimary--text">
                                {{ getFullName?.toUpperCase() }}
                            </v-card-subtitle>
                        <v-row>
                        <v-col cols="12" class="d-flex justify-space-between">
                            <v-row>
                            <v-col cols="6" md="3" class="appdetalleplaza">
                                <p>Tipo documento</p>
                                <p>{{ dataObject?.tipo_documento?.toUpperCase() }}</p>
                            </v-col>
                            <v-col cols="6" md="3" class="appdetalleplaza">
                                <p>N° documento</p>
                                <p>{{ dataObject?.numero_documento }}</p>
                            </v-col>
                            <v-col cols="6" md="3" class="appdetalleplaza">
                                <p>Departamento de residencia</p>
                                <p> {{ dataObject?.departamento_residencia?.toUpperCase() }}</p>
                            </v-col>
                            <v-col cols="6" md="3" class="appdetalleplaza">
                                <p>Distrito de residencia</p>
                                <p> {{ dataObject?.distrito_residencia?.toUpperCase() }}</p>
                            </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" class="d-flex justify-space-between">
                        <v-row>
                            <v-col cols="6" md="3" class="appdetalleplaza">
                            <p>Dirección</p>
                            <p> {{ dataObject?.direccion?.toUpperCase() }}</p>
                            </v-col>
                            <v-col cols="6" md="3" class="appdetalleplaza">
                            <p>Email institucional</p>
                            <p>{{ dataObject?.email_institucional?.toUpperCase()  }}</p>
                            </v-col>
                            <v-col cols="6" md="3" class="appdetalleplaza" >
                            <p>Teléfono personal</p>
                            <p>{{ dataObject?.telefono_personal}}</p>
                            </v-col>
                            <v-col cols="6" md="3" class="appdetalleplaza" >
                            <p>Institución</p>
                            <p>{{ dataObject?.institucion?.toUpperCase() }}</p>
                            </v-col>
                        </v-row>
                        </v-col>
                        <v-col>
                        <v-row>
                            <v-col cols="6" md="3" class="appdetalleplaza">
                                <p>Establecimiento</p>
                                <p>{{ dataObject?.establecimiento?.toUpperCase()  }}</p>
                            </v-col>
                            <v-col cols="6" md="3" class="appdetalleplaza">
                                <p>Unidad organizativa</p>
                                <p>{{ dataObject?.unidad_organizativa?.toUpperCase() }}</p>
                            </v-col>
                            <v-col cols="6" md="3" class="appdetalleplaza">
                                <p>Cargo funcional</p>
                                <p>{{ dataObject?.cargo?.toUpperCase()}}</p>
                            </v-col>
                            <v-col cols="6" md="3" class="appdetalleplaza">
                                <p>Jefatura</p>
                                <p>{{ dataObject?.jefatura ? 'Sí': 'No' }}</p>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" md="3" class="appdetalleplaza">
                                <p>Fecha de ingreso a gobierno</p>
                                <p>{{ moment(dataObject?.fecha_ingreso).format("DD/MM/YYYY") || '-' }}</p>
                            </v-col>
                            <v-col cols="6" md="3" class="appdetalleplaza">
                                <p>Fecha de contratación</p>
                                <p>{{ moment(dataObject?.fecha_contratacion).format("DD/MM/YYYY") || '-' }}</p>
                            </v-col>
                            <v-col cols="6" md="3" class="appdetalleplaza">
                                <p>Estado empleado</p>
                                <p>{{ dataObject?.estado_empleado?.toUpperCase() }}</p>
                            </v-col>
                        </v-row>
                        </v-col>
                        </v-row>
                    </v-col>
                    </v-row>
                </v-card-text>

            </v-card>

                <v-card class="mt-5 rounded-t-xl">
                    <v-toolbar dark color="bluePrimary" class="scroll" style="border-radius: 10px 10px 0px 0px;">
                        <v-toolbar-title>Datos de la plaza</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text class="pt-5">
                        <v-row>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="6" md="3" class="appdetalleplaza">
                                    <p>Plaza</p>
                                    <p>{{ dataObject?.plaza?.toUpperCase() }}</p>
                                </v-col>
                                <v-col cols="6" md="3" class="appdetalleplaza">
                                    <p>Cifrado presupuestario</p>
                                    <p>{{ dataObject?.cifrado }}</p>
                                </v-col>
                                <v-col cols="6" md="3" class="appdetalleplaza">
                                    <p>Unidad presupuestaria</p>
                                    <p>{{ dataObject?.unidad_presupuestaria }}</p>
                                </v-col>
                                <v-col cols="6" md="3" class="appdetalleplaza">
                                    <p>Línea de trabajo</p>
                                    <p>{{ dataObject?.linea_trabajo }}</p>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="6" md="3" class="appdetalleplaza">
                                    <p>Partida</p>
                                    <p>{{ dataObject?.partida}}</p>
                                </v-col>
                                <v-col cols="6" md="3" class="appdetalleplaza">
                                    <p>Subpartida</p>
                                    <p>{{ dataObject?.sub_partida }}</p>
                                </v-col>
                                <v-col cols="6" md="3" class="appdetalleplaza">
                                    <p>Tipo de financiamiento</p>
                                    <p>{{ dataObject?.tipo_financiamiento?.toUpperCase() }}</p>
                                </v-col>
                                <v-col cols="6" md="3" class="appdetalleplaza">
                                    <p>Especifico de gasto</p>
                                    <p>{{ dataObject?.especifico_gasto?.toUpperCase() }}</p>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="6" md="3" class="appdetalleplaza">
                                    <p>Sueldo mínimo de la plaza</p>
                                    <p>{{ dataObject?.sueldo_minimo ? '$ '+ dataObject?.sueldo_minimo : '-' }}</p>
                                </v-col>
                                <v-col cols="6" md="3" class="appdetalleplaza">
                                    <p>Sueldo máximo de la plaza</p>
                                    <p>{{ dataObject?.sueldo_maximo ? '$ ' + dataObject?.sueldo_maximo : '-' }}</p>
                                </v-col>
                                <v-col cols="6" md="3" class="appdetalleplaza">
                                    <p>Salario del empleado</p>
                                    <p>{{ dataObject?.salario ? '$ ' + dataObject?.salario : '-' }}</p>
                                </v-col>
                                <v-col cols="6" md="3" class="appdetalleplaza">
                                    <p>Sistema de pago</p>
                                    <p>{{ dataObject?.sistema_pago?.toUpperCase() }}</p>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols="6" md="3" class="appdetalleplaza">
                                    <p>Número de horas del empleado</p>
                                    <p>{{ dataObject?.horas_plaza }}</p>
                                </v-col>
                                <v-col cols="6" md="3" class="appdetalleplaza">
                                    <p>Fecha de nombramiento</p>
                                    <p>{{ moment(dataObject?.fecha_nombramiento).format("DD/MM/YYYY") || '-' }}</p>
                                </v-col>
                                <v-col cols="6" md="3" class="appdetalleplaza"></v-col>
                                <v-col cols="6" md="3" class="appdetalleplaza"></v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    </v-card-text>
                </v-card>
            <div class=" d-flex justify-center">
                <v-btn color="bluePrimary" dark outlined rounded class="text-capitalize ma-2" @click="closeDialog()">
                    Cerrar
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: "detalleEmpleado",
    props: {
        dataObject: {
            type: Object,
            required: true,
            default: () => ({})
        },
        closeDialog: {
            type: Function,
            required: true
        },
        dialogEmpleado: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
        };
    },
    methods: {
        // formatear fecha en dia/mes/año
        formatDate(date) {
            if (date) {
                const [year, month, day] = date.split("-");
                return `${day}/${month}/${year}`;
            }else{
                return 'Sin fecha';
            }
        },
        // mostrar imagen cuando no sea xs y md
        showImage() {
            return !this.$vuetify.breakpoint.xs && !this.$vuetify.breakpoint.md;
        },
    },
    mounted() {
        // mounted
    },
    computed: {
        getFullName() {
            let fullName = "";
            if (this.dataObject?.primer_nombre) {
                fullName += this.dataObject?.primer_nombre;
            }
            if (this.dataObject?.segundo_nombre && this.dataObject?.segundo_nombre != '-') {
                fullName += " " + this.dataObject?.segundo_nombre;
            }
            if (this.dataObject?.primer_apellido) {
                fullName += " " + this.dataObject?.primer_apellido;
            }
            if (this.dataObject?.segundo_apellido && this.dataObject?.segundo_apellido != '-') {
                fullName += " " + this.dataObject?.segundo_apellido;
            }
            return fullName.toUpperCase();
        },
    },
    created() {
    },
};
</script>
<style scope>
/* styles */

.appdetalleplaza > p {
	margin: 0;
    color: gray;
}
.appdetalleplaza > p:last-child {
	font-weight: bold;
	font-size: 1rem;
}

.no-padding {
    margin-bottom: 0 !important;
    padding: 0 !important;
}

.wrapper {
    display: flex;
    margin: 10px;
}

.one {
    flex: 1;
    background-size: cover;
}

.two {
    flex: 6;
}

.scroll {
    overflow: hidden;
}
.v-dialog {
    border-radius: 40px;
    margin: 24px;
    overflow-y: auto;
    pointer-events: auto;
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    width: 100%;
    z-index: inherit;
    outline: none;
    color:#616161;
    /* box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12); */
}
.v-dialog p{ 
    color:#616161 !important;
}

</style>
